import React, { useEffect, useRef } from 'react';
import { Paper, Stack, Box } from '@mui/material';

import StyledTextField from '@shared/components/StyledTextField';

import SubsidiaryCard from './SubsidiaryCard';

const SubsidiariesList = ({
  sucursalesFiltered,
  textFilter,
  handleTextChange,
  changeSuc,
  name,
  selectedKey,
  scrollToKey,
}) => {
  const itemRefs = useRef({});

  useEffect(() => {
    if (!scrollToKey) return;
    itemRefs.current[scrollToKey]?.scrollIntoView({
      behavior: 'smooth',
      block: 'nearest',
    });
  }, [scrollToKey]);

  return (
    <Stack
      id="sucursales-list-stack"
      component="section"
      spacing={2}
      sx={{
        width: '100%',
        bgcolor: 'white',
      }}
    >
      <Box sx={{ m: '20px 20px 0px 20px !important' }}>
        <StyledTextField
          fullWidth
          label="Buscar franquicia cercana"
          InputLabelProps={{ shrink: true }}
          value={textFilter}
          onChange={handleTextChange}
          textFieldSx={{ fontSize: 14.4, mb: 2 }}
        />
      </Box>
      <Paper
        sx={{
          borderRadius: 2,
          padding: '16px 0px 16px 16px',
          maxHeight: '70vh',
          overflowY: 'auto',
          overflowX: 'hidden',
          m: '0px 20px!important',
        }}
        elevation={5}
      >
        <Box
          id="grid-sucursales-filtered"
          spacing={1}
          sx={{ display: 'flex', flexDirection: 'column' }}
        >
          {sucursalesFiltered.length > 0 ? (
            sucursalesFiltered.map(sucursal => {
              const key = sucursal.id ?? sucursal.name;
              return (
                <Box key={key} ref={el => (itemRefs.current[key] = el)}>
                  <SubsidiaryCard
                    sucursal={sucursal}
                    onSelect={() => changeSuc(sucursal)}
                    name={name}
                    isSelected={selectedKey === key}
                  />
                </Box>
              );
            })
          ) : (
            <Box
              sx={{
                textAlign: 'center',
                p: 1,
                color: 'black',
                fontSize: '18px',
              }}
            >
              Buscando sucursales...
            </Box>
          )}
        </Box>
      </Paper>
    </Stack>
  );
};

export default SubsidiariesList;
